import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customtitlecase',
})
export class CustomTitleCasePipe implements PipeTransform {
  transform(fullName: string): any {
    let string = fullName
      ?.split(' ')
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
    if (string?.indexOf('.') > 0) {
      string = string
        ?.split('.')
        .map((word) => {
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join('.');
    }
    return string;
  }
}
